import { createSelector } from 'reselect'

import { selectSiteBuilderState } from 'core-components/sitebuilder/store/selectors/selectSitebuilderSelectors'

export const selectFlexSettings = createSelector(
  [selectSiteBuilderState],
  ({ flexSettings }) => flexSettings
)
